import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	@media(min-width: 601px) {
		> main {
			margin-left: 48px;
		}
	}

	> footer {
		margin-left: 48px;
		
		@media(max-width: 600px) {
			margin-left: 0;
		}
	}

	@media(min-width: 1024px) {
		> main,
		> footer {
			margin-left: 12rem;
		}
	}
`
